'use client';

import styled from 'styled-components';

import { cssVar, theme } from '@zoomit/zoomit-ds';

type Props = {
  position: 'top-right' | 'top-left';
  backgroundColor?: string;
  offset?: number;
};

const EllipticBox = styled.div<Props>`
  z-index: 6;
  padding: 0.5rem 1.3rem;
  border-radius: 1.2rem;
  background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : cssVar(theme.black1))};
  width: fit-content;
  position: absolute;
  top: ${({ offset }) => (offset ? offset : 1.4)}rem;
  ${({ position, offset }) =>
    position === 'top-right' ? `right: ${offset || 1.4}rem;` : `left: ${offset || 1.4}rem;`}
`;

export default EllipticBox;
